import { Box } from '@mui/material';
import React, { memo } from 'react';
import { CartItem, CartModifierGroup } from '../../../utils/cart';
import { SelectMenuItemModifier } from './modGroup.props';
import { checkItemInCartItemTree, sortModGroups } from '../../../utils/menu';
import ModGroup from '../menu/ModGroup';
import { ParsedModifierGroup } from '../../../types/menu';
import { getMenuUnificationFeatureFlag } from '../../../utils/session-storage';
import { useSelector } from 'react-redux';
import {
  selectDialogSelectedModGroup,
  selectSelectedItemCartId,
} from '../../../selectors/dialog';
import { RootState } from '../../../app/store';

interface IRecursiveModGroup {
  cartItem: CartItem;
  modGroup: ParsedModifierGroup;
  onChange: (
    modGroup: ParsedModifierGroup
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectMenuItemModifier: SelectMenuItemModifier;
  pathToItem: string;
  isHighlighted?: boolean;
  isSelectedToFocus?: boolean;
}

const RecursiveModGroup = (props: IRecursiveModGroup) => {
  const { modGroup, cartItem, pathToItem, isSelectedToFocus, isHighlighted } =
    props;
  const selectedModGroup = useSelector(selectDialogSelectedModGroup);
  const { selectedModGroupPath } = useSelector(
    (state: RootState) => state.dialog
  );
  const selectedItemCartId = useSelector(selectSelectedItemCartId);

  const currentItem =
    (checkItemInCartItemTree({ cartItem, pathToItem }) as CartModifierGroup) ||
    {};

  if (!currentItem?.selectedItems) return null;

  const renderedModGroupIds: Record<string, boolean> = {};
  // Singular selection, so the value is the first key in `selectedItems`
  return (
    <Box>
      {Object.values(currentItem?.selectedItems)
        .sort(
          (itemA, itemB) =>
            (itemA.parentModifierGroupIndex || 0) -
            (itemB.parentModifierGroupIndex || 0)
        )
        .map(({ id, itemId }) => {
          const modGroupChildren = sortModGroups(modGroup.menuItems[itemId]);
          const filteredModGroups = getMenuUnificationFeatureFlag()
            ? Object.values(modGroupChildren)
            : Object.values(modGroupChildren).filter(
                (mod) => !renderedModGroupIds[mod.name]
              );
          const key = [id, modGroup.id, 'sub_choices'].join('_');
          const updatedPathToItem = [pathToItem, id].join('__');
          if (filteredModGroups.length) {
            return (
              <Box key={key}>
                {filteredModGroups.map((modGroup) => {
                  renderedModGroupIds[modGroup.name] = true;
                  const modGroupProps = {
                    ...props,
                    modGroup,
                    pathToItem: [updatedPathToItem, modGroup.id].join('__'),
                    isSelectedToFocus:
                      (selectedModGroupPath ===
                        [updatedPathToItem, modGroup.id].join('__') &&
                        selectedItemCartId === cartItem.cartItemId) ||
                      !!isSelectedToFocus,
                  };
                  return <ModGroup key={modGroup.id} {...modGroupProps} />;
                })}
              </Box>
            );
          }
          return <></>;
        })}
    </Box>
  );
};

export default memo(RecursiveModGroup);
